// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__dFbpQ","sm":"Tag_sm__+s2Gk"};